import { ApplicationConfig, enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { provideAnimations } from '@angular/platform-browser/animations';
import { L10n, registerLicense } from '@syncfusion/ej2-base';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

registerLocaleData(localePt);

L10n.load({
  'en': {
    grid: {
      EmptyRecord: 'No records to display',
      PagerInfo: '{0} of {1} pages ({2} items)',
      ItemsPerPage: 'Items per page',
      FirstPageTooltip: 'Go to the first page',
      LastPageTooltip: 'Go to the last page',
      NextPageTooltip: 'Go to the next page',
      PreviousPageTooltip: 'Go to the previous page',
      NextPagerTooltip: 'Go to the next set of pages',
      PreviousPagerTooltip: 'Go to the previous set of pages',
      Search: 'Search',
      Matchs: 'No matches found',
      FilterButton: 'Filter',
      ClearButton: 'Clear',
      EnterValue: 'Enter the value'
    },
    pager: {
      currentPageInfo: '{0} of {1} pages',
      totalItemsInfo: '({0} items)',
      firstPageTooltip: 'Go to the first page',
      lastPageTooltip: 'Go to the last page',
      nextPageTooltip: 'Go to the next page',
      previousPageTooltip: 'Go to the previous page',
      nextPagerTooltip: 'Go to the next set of pages',
      previousPagerTooltip: 'Go to the previous set of pages',
      pagerDropDown: 'Items per page',
      pagerAllDropDown: 'Items',
      All: 'All',
      Page: 'Page',
      Of: 'of',
      Pages: 'pages'
    }
  },
  'pt': {
    grid: {
      EmptyRecord: 'Sem registros para exibir',
      PagerInfo: '{0} de {1} páginas ({2} itens)',
      ItemsPerPage: 'Itens por página',
      FirstPageTooltip: 'Ir para a primeira página',
      LastPageTooltip: 'Ir para a última página',
      NextPageTooltip: 'Ir para a próxima página',
      PreviousPageTooltip: 'Ir para a página anterior',
      NextPagerTooltip: 'Ir para o próximo conjunto de páginas',
      PreviousPagerTooltip: 'Ir para o conjunto anterior de páginas',
      Search: 'Pesquisar',
      Matchs: 'Nenhum resultado encontrado',
      FilterButton: 'Filtrar',
      ClearButton: 'Limpar',
      EnterValue: 'Digite o valor'
    },
    pager: {
      currentPageInfo: '{0} de {1} páginas',
      totalItemsInfo: '({0} itens)',
      firstPageTooltip: 'Ir para a primeira página',
      lastPageTooltip: 'Ir para a última página',
      nextPageTooltip: 'Ir para a próxima página',
      previousPageTooltip: 'Ir para a página anterior',
      nextPagerTooltip: 'Ir para o próximo conjunto de páginas',
      previousPagerTooltip: 'Ir para o conjunto anterior de páginas',
      pagerDropDown: 'Itens por página',
      pagerAllDropDown: 'Itens',
      All: 'Todos',
      Page: 'Página',
      Of: 'de',
      Pages: 'páginas'
    }
  },
  'es': {
    grid: {
      EmptyRecord: 'No hay registros para mostrar',
      PagerInfo: '{0} de {1} páginas ({2} elementos)',
      ItemsPerPage: 'Elementos por página',
      FirstPageTooltip: 'Ir a la primera página',
      LastPageTooltip: 'Ir a la última página',
      NextPageTooltip: 'Ir a la página siguiente',
      PreviousPageTooltip: 'Ir a la página anterior',
      NextPagerTooltip: 'Ir al siguiente conjunto de páginas',
      PreviousPagerTooltip: 'Ir al conjunto anterior de páginas',
      Search: 'Buscar',
      Matchs: 'No se encontraron resultados',
      FilterButton: 'Filtrar',
      ClearButton: 'Limpiar',
      EnterValue: 'Ingrese el valor'
    },
    pager: {
      currentPageInfo: '{0} de {1} páginas',
      totalItemsInfo: '({0} elementos)',
      firstPageTooltip: 'Ir a la primera página',
      lastPageTooltip: 'Ir a la última página',
      nextPageTooltip: 'Ir a la página siguiente',
      previousPageTooltip: 'Ir a la página anterior',
      nextPagerTooltip: 'Ir al siguiente conjunto de páginas',
      previousPagerTooltip: 'Ir al conjunto anterior de páginas',
      pagerDropDown: 'Elementos por página',
      pagerAllDropDown: 'Elementos',
      All: 'Todos',
      Page: 'Página',
      Of: 'de',
      Pages: 'páginas'
    }
  }
});

if (environment.production) {
  enableProdMode();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations()
  ]
};

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

registerLicense('Ngo9BigBOggjHTQxAR8/V1JEaF5cXmRCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXhfd3RdQmdfVUx+WERWYEE=');
